export default defineNuxtRouteMiddleware((to, from) => {
  const user = useUser()
  const session = useVisitorSession()
  const t = useI18n().t
  // console.log('checking account status (middleware):', to, from)
  if (!session.realAdmin && user.extra.suspend) {
    // console.log(`account ${user.id} suspended. session is admind:`, session.realAdmin)
    abortNavigation(createError({
      statusCode: 403,
      message: t('errors.account_suspended.message'),
      data: t('errors.account_suspended.title'),
      fatal: true,
    }))
    // abortNavigation(new Error('Test Error'))
  }
  // console.log('account seems okay.')
})
